// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CoverMyMedsV1ClientGeneratedHubEnrollmentModel } from './coverMyMedsV1ClientGeneratedHubEnrollmentModel.js';
import type { CoverMyMedsV1ClientGeneratedWorkflowModel } from './coverMyMedsV1ClientGeneratedWorkflowModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedEnrollmentRequestModel {
    'caseKey'?: string | null;
    'hubEnrollment'?: CoverMyMedsV1ClientGeneratedHubEnrollmentModel | null;
    'workflow'?: CoverMyMedsV1ClientGeneratedWorkflowModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedEnrollmentRequestModel>> = [
        {
            "name":     "caseKey",
            "baseName": "caseKey",
            "type":     "string"
        },
        {
            "name":     "hubEnrollment",
            "baseName": "hubEnrollment",
            "type":     "CoverMyMedsV1ClientGeneratedHubEnrollmentModel"
        },
        {
            "name":     "workflow",
            "baseName": "workflow",
            "type":     "CoverMyMedsV1ClientGeneratedWorkflowModel"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedEnrollmentRequestModel.attributeTypeMap;
    }
}
